import type { MRT_ColumnDef } from "mantine-react-table-open";
import { sortBackendDates } from "../../../../../utils/dates/sortBackendDates";
import type { MeterConfigurationData } from "../../../ThirdPartySystems.types";

function getQivaloColumns(): Array<MRT_ColumnDef<MeterConfigurationData>> {
  return [
    {
      header: "Windpark",
      accessorKey: "parameters.propertyName",
      minSize: 150
    },
    {
      header: "Seriennummer des Zählers",
      accessorKey: "parameters.serialNumber",
      minSize: 160
    },
    { header: "Medium", accessorKey: "parameters.medium", size: 100 },
    {
      header: "Datum der Zählerinstallation",
      accessorKey: "parameters.installationDate",
      size: 150,
      sortingFn: (rowA, rowB) =>
        "installationDate" in rowA.original.parameters &&
        "installationDate" in rowB.original.parameters
          ? sortBackendDates(
              rowA.original.parameters.installationDate,
              rowB.original.parameters.installationDate
            )
          : 0,
      Cell: ({ renderedCellValue }) => renderedCellValue || "Unbekannt"
    },
    { header: "Einheit", accessorKey: "parameters.units", size: 100 },
    { header: "Messstellen-ID", accessorKey: "parameters.nodeId", minSize: 170 }
  ];
}

export { getQivaloColumns };
